const styles = theme => ({
  sideItems: {
    width:"80%",
    height:"80%",
    paddingLeft: 25,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/SideDrawer/components/DrawerMenu/styles.js